import logo from "../img/PCLC.svg";

function Navbar() {
    return (
        <nav className="auth-navbar">
            <img src={logo} alt="PalCare" className="auth-navbar__logo" />
            <ul className="auth-navbar__links">
                <li>
                    <a href="https://www.palcare.com/" className="auth-navbar__link">
                        <i className="fe fe-home" /> Home
                    </a>
                </li>
                <li>
                    <a href="https://shop.palcare.com/" className="auth-navbar__link">
                        <i className="fe fe-shopping-cart" /> Shop
                    </a>
                </li>
                <li>
                    <a href="https://www.palcare.com/contact-us/" className="auth-navbar__link">
                        <i className="fe fe-phone-call" /> Contact
                    </a>
                </li>
            </ul>
        </nav>
    );
}

export default Navbar;
